import * as types from '../mutation-types';
import store from '../index';
import EventBus from '../../Buss/EventBus';

// initial state
const state = {
  wallets: [],
};

// getters
const getters = {
  getAccounts: state => state.wallets,
};

// mutations
const mutations = {
  [types.STORE_ACCOUNT](state, wallet) {
    state.wallets.push(wallet);
  },
  [types.STORE_ACCOUNTS](state, accounts) {
    state.wallets = accounts;
  },
};

// actions
const actions = {
  storeAccount(context, wallet) {
    context.commit('STORE_ACCOUNT', wallet);
  },
  purge(context) {
    /* eslint no-var: "off" */
    /* eslint block-scoped-var: "off" */
    /* eslint vars-on-top: "off" */
    var index = store.getters.getAuth.index;
    const accounts = context.getters.getAccounts;
    const newAccounts = [...accounts];

    EventBus.$emit('logout', {
      login: false,
    });
    EventBus.$emit('home');
    newAccounts.splice(index, 1);
    context.commit('STORE_ACCOUNTS', newAccounts);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/accounts.js